import { PageModule } from "@/routes/types";
import { loader } from "./loader";
import { Page } from "./page";

export default { name: "GoalAddPage", loader, Page } as PageModule;

export interface UrlParams {
  companyWide?: boolean;
  parentGoalId?: string;
  spaceId?: string;
}
